var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "modal",
        {
          staticClass: "custom-modal",
          attrs: {
            name: "configureSchedulerModal",
            width: "75%",
            height: "auto",
            scrollable: true,
            pivotX: 1.0,
            minWidth: 900,
            minHeight: 900,
            clickToClose: true
          },
          on: { "before-open": _vm.beforeOpen, "before-close": _vm.beforeClose }
        },
        [
          _c(
            "div",
            {
              staticClass: "overlay",
              class: { isLoading: _vm.isLoading, noDisplay: !_vm.isLoading }
            },
            [
              _c(
                "div",
                { staticClass: "spinner-align" },
                [
                  _c("Icon", {
                    staticClass: "icon-size",
                    attrs: { name: "spinner", scale: "5", pulse: "" }
                  })
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          !_vm.isLoading
            ? _c(
                "div",
                { staticClass: "modal-padding", on: { click: _vm.onSave } },
                [
                  _c("div", { staticClass: "page-title" }, [
                    _c("div", { staticClass: "col-md-6 noPaddingLeft" }, [
                      _c("span", { staticClass: "h2-text" }, [
                        _vm._v(
                          _vm._s(_vm.configurations.clientName) +
                            "'s - Configure Scheduler"
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "col-md-6 noPaddingRight align-right-item"
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "modal-close-img",
                            on: { click: _vm.hideModal }
                          },
                          [_c("span", { staticClass: "icon-close" })]
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row mt-4" }, [
                    _c("div", { staticClass: "col-md-6" }, [
                      _c(
                        "button",
                        {
                          staticClass: "ap-btn secondary",
                          on: {
                            click: function($event) {
                              _vm.handleOpenSchedulerPreview()
                            }
                          }
                        },
                        [_vm._v("Preview Scheduler")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-3" }, [
                      _c(
                        "div",
                        { staticClass: "float-right" },
                        [
                          _c("Toggle", {
                            attrs: { text: "Online Scheduler" },
                            model: {
                              value: _vm.configurations.live,
                              callback: function($$v) {
                                _vm.$set(_vm.configurations, "live", $$v)
                              },
                              expression: "configurations.live"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-3" }, [
                      _c(
                        "div",
                        { staticClass: "float-right" },
                        [
                          _c("Toggle", {
                            attrs: {
                              text: "Online Scheduler for Test Accounts"
                            },
                            model: {
                              value: _vm.configurations.liveTestUser,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.configurations,
                                  "liveTestUser",
                                  $$v
                                )
                              },
                              expression: "configurations.liveTestUser"
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "scheduler mt-4" }, [
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col text-entry-field-wrapper" },
                        [
                          _c("span", { staticClass: "text-entry-title" }, [
                            _vm._v("Scheduler name")
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.configurations.name,
                                expression: "configurations.name"
                              }
                            ],
                            staticClass: "text-input",
                            attrs: { placeholder: "Enter your scheduler name" },
                            domProps: { value: _vm.configurations.name },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.configurations,
                                  "name",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col text-entry-field-wrapper" },
                        [
                          _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              { staticClass: "col text-entry-field-wrapper" },
                              [
                                _c(
                                  "span",
                                  { staticClass: "text-entry-title" },
                                  [_vm._v("URL Hyperlink Color")]
                                ),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.configurations.urlHyperlinkColor,
                                      expression:
                                        "configurations.urlHyperlinkColor"
                                    }
                                  ],
                                  staticClass: "text-input",
                                  attrs: { placeholder: "Enter a HEX code" },
                                  domProps: {
                                    value: _vm.configurations.urlHyperlinkColor
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.configurations,
                                        "urlHyperlinkColor",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col text-entry-field-wrapper" },
                              [
                                _c(
                                  "span",
                                  { staticClass: "text-entry-title" },
                                  [_vm._v("Branded URL")]
                                ),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.configurations.brandedURL,
                                      expression: "configurations.brandedURL"
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required|url:require_protocol",
                                      expression:
                                        "'required|url:require_protocol'"
                                    }
                                  ],
                                  staticClass: "text-input",
                                  attrs: {
                                    name: "brandedURL",
                                    placeholder: "Branded URL"
                                  },
                                  domProps: {
                                    value: _vm.configurations.brandedURL
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.configurations,
                                        "brandedURL",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "branded-url-error" },
                                  [
                                    _vm.errors.has("brandedURL")
                                      ? _c("div", {
                                          staticClass: "alert-icon-red-error"
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "error-text-color" },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.errors.first("brandedURL"))
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            )
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "row mt-3 flex-column align-items-end" },
                      [
                        _c(
                          "div",
                          { staticClass: "col-md-6 text-entry-field-wrapper" },
                          [
                            _c("span", { staticClass: "text-entry-title" }, [
                              _vm._v("ShiftBoard Lead WorkGroup")
                            ]),
                            _vm._v(" "),
                            _c("multiselect", {
                              staticClass: "multiple-select-work-group",
                              attrs: {
                                options: _vm.allWorkGroups,
                                placeholder: "Choose Lead WorkGroup",
                                label: "name",
                                openDirection: "below",
                                multiple: false,
                                "close-on-select": true,
                                "hide-selected": true,
                                "track-by": "id",
                                "allow-empty": false,
                                "show-labels": false,
                                disabled: false
                              },
                              on: { select: _vm.dropdownItemClick },
                              model: {
                                value: _vm.dropdowntitle,
                                callback: function($$v) {
                                  _vm.dropdowntitle = $$v
                                },
                                expression: "dropdowntitle"
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "text-entry-title" }, [
                              _vm._v("ShiftBoard Screener WorkGroup")
                            ]),
                            _vm._v(" "),
                            _c("multiselect", {
                              staticClass: "multiple-select-work-group",
                              attrs: {
                                options: _vm.allWorkGroups,
                                placeholder: "Choose Screener WorkGroup",
                                label: "name",
                                openDirection: "below",
                                multiple: false,
                                "close-on-select": true,
                                "hide-selected": true,
                                "track-by": "id",
                                "allow-empty": false,
                                "show-labels": false,
                                disabled: false
                              },
                              on: { select: _vm.screenerDropdownItemClick },
                              model: {
                                value: _vm.screenerDropdowntitle,
                                callback: function($$v) {
                                  _vm.screenerDropdowntitle = $$v
                                },
                                expression: "screenerDropdowntitle"
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "text-entry-title" }, [
                              _vm._v("ShiftBoard Phlebotomist WorkGroup")
                            ]),
                            _vm._v(" "),
                            _c("multiselect", {
                              staticClass: "multiple-select-work-group",
                              attrs: {
                                options: _vm.allWorkGroups,
                                placeholder: "Choose Phlebotomist WorkGroup",
                                label: "name",
                                openDirection: "below",
                                multiple: false,
                                "close-on-select": true,
                                "hide-selected": true,
                                "track-by": "id",
                                "allow-empty": false,
                                "show-labels": false,
                                disabled: false
                              },
                              on: { select: _vm.phlebotomistDropdownItemClick },
                              model: {
                                value: _vm.phlebotomistDropdowntitle,
                                callback: function($$v) {
                                  _vm.phlebotomistDropdowntitle = $$v
                                },
                                expression: "phlebotomistDropdowntitle"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "row mt-3" }, [
                      _c(
                        "div",
                        { staticClass: "col text-entry-field-wrapper" },
                        [
                          _c("span", { staticClass: "text-entry-title" }, [
                            _vm._v("Landing Page Top Text")
                          ]),
                          _vm._v(" "),
                          _c("vue-ckeditor", {
                            attrs: { config: _vm.config },
                            model: {
                              value: _vm.configurations.landingTopText,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.configurations,
                                  "landingTopText",
                                  $$v
                                )
                              },
                              expression: "configurations.landingTopText"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col text-entry-field-wrapper" },
                        [
                          _c("span", { staticClass: "text-entry-title" }, [
                            _vm._v("Landing Page Bottom Text")
                          ]),
                          _vm._v(" "),
                          _c("vue-ckeditor", {
                            attrs: { config: _vm.config },
                            model: {
                              value: _vm.configurations.landingBottomText,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.configurations,
                                  "landingBottomText",
                                  $$v
                                )
                              },
                              expression: "configurations.landingBottomText"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row mt-3" }, [
                      _c(
                        "div",
                        { staticClass: "col text-entry-field-wrapper" },
                        [
                          _c("span", { staticClass: "text-entry-title" }, [
                            _vm._v("Thank you page text")
                          ]),
                          _vm._v(" "),
                          _c("vue-ckeditor", {
                            attrs: { config: _vm.config },
                            model: {
                              value: _vm.configurations.landingThankYouText,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.configurations,
                                  "landingThankYouText",
                                  $$v
                                )
                              },
                              expression: "configurations.landingThankYouText"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "col" })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("hr", { staticClass: "mt-4 mb-4" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "configurations" }, [
                    _c("div", { staticClass: "title" }, [
                      _vm._v("Configurations")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row mt-3" }, [
                      _c(
                        "div",
                        { staticClass: "col-md-4" },
                        [
                          _c("Toggle", {
                            attrs: { text: "Allow walk-ins" },
                            model: {
                              value: _vm.configurations.allowWithoutLimeade,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.configurations,
                                  "allowWithoutLimeade",
                                  $$v
                                )
                              },
                              expression: "configurations.allowWithoutLimeade"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-md-4" },
                        [
                          _c("Toggle", {
                            attrs: { text: "Spouse appointment" },
                            model: {
                              value: _vm.configurations.allowBookForSpouse,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.configurations,
                                  "allowBookForSpouse",
                                  $$v
                                )
                              },
                              expression: "configurations.allowBookForSpouse"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-md-4" },
                        [
                          _c("Toggle", {
                            attrs: { text: "Participant Survey" },
                            model: {
                              value:
                                _vm.configurations.allowSendParticipantSurvey,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.configurations,
                                  "allowSendParticipantSurvey",
                                  $$v
                                )
                              },
                              expression:
                                "configurations.allowSendParticipantSurvey"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row mt-3" }, [
                      _c(
                        "div",
                        { staticClass: "col-md-4 text-entry-field-wrapper" },
                        [
                          _c("Toggle", {
                            attrs: {
                              text:
                                "Vaccine Appointment (Flu shots/Covid Vaccines)",
                              disabled: !_vm.enableBookVaccineAtClient
                            },
                            model: {
                              value: _vm.configurations.allowBookFluShot,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.configurations,
                                  "allowBookFluShot",
                                  $$v
                                )
                              },
                              expression: "configurations.allowBookFluShot"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-md-4 text-entry-field-wrapper" },
                        [
                          _c("div", [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "text-entry-title display-flex-end",
                                class: {
                                  "opacity-06": !_vm.configurations
                                    .allowBookForSpouse
                                }
                              },
                              [
                                _c("span", [_vm._v("Spouse Label")]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "display-space-between",
                                    class: {
                                      noDisplay: !_vm.configurations
                                        .allowBookForSpouse
                                    }
                                  },
                                  [
                                    _vm.errors.has("spouse")
                                      ? _c("span", {
                                          staticClass: "alert-icon-red-error"
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "error-text-color" },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.errors.first("Spouse"))
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.configurations.spouseLabel,
                                  expression: "configurations.spouseLabel"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              staticClass: "text-input",
                              class: {
                                "opacity-06": !_vm.configurations
                                  .allowBookForSpouse
                              },
                              attrs: {
                                disabled: !_vm.configurations
                                  .allowBookForSpouse,
                                name: "Spouse",
                                placeholder: "Enter Spouse Label"
                              },
                              domProps: {
                                value: _vm.configurations.spouseLabel
                              },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.configurations,
                                    "spouseLabel",
                                    $event.target.value
                                  )
                                }
                              }
                            })
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-md-4 text-entry-field-wrapper" },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "text-entry-title",
                              class: {
                                "opacity-06": !_vm.configurations
                                  .allowSendParticipantSurvey
                              }
                            },
                            [_vm._v("Biometrics Survey URL")]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value:
                                  _vm.configurations.surveyBiometricResultUrl,
                                expression:
                                  "configurations.surveyBiometricResultUrl"
                              }
                            ],
                            staticClass: "text-input",
                            class: {
                              "opacity-06": !_vm.configurations
                                .allowSendParticipantSurvey
                            },
                            attrs: {
                              value: "configurations.surveyBiometricResultUrl",
                              disabled: !_vm.configurations
                                .allowSendParticipantSurvey,
                              placeholder: "Enter Biometrics Survey Link"
                            },
                            domProps: {
                              value: _vm.configurations.surveyBiometricResultUrl
                            },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.configurations,
                                  "surveyBiometricResultUrl",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row mt-3" }, [
                      _c(
                        "div",
                        { staticClass: "col-md-4" },
                        [
                          _c("Toggle", {
                            attrs: { text: "ZenDesk" },
                            model: {
                              value: _vm.configurations.zendeskConfiguration,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.configurations,
                                  "zendeskConfiguration",
                                  $$v
                                )
                              },
                              expression: "configurations.zendeskConfiguration"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-md-4" },
                        [
                          _c("Toggle", {
                            attrs: { text: "Multiple Screenings Per Year" },
                            model: {
                              value:
                                _vm.configurations.multipleScreeningsPerYear,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.configurations,
                                  "multipleScreeningsPerYear",
                                  $$v
                                )
                              },
                              expression:
                                "configurations.multipleScreeningsPerYear"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-md-4" },
                        [
                          _c("Toggle", {
                            attrs: { text: "Screening Related SMS" },
                            model: {
                              value: _vm.configurations.enableSMSReminder,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.configurations,
                                  "enableSMSReminder",
                                  $$v
                                )
                              },
                              expression: "configurations.enableSMSReminder"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row mt-3" }, [
                      _c(
                        "div",
                        { staticClass: "col-md-4" },
                        [
                          _c("Toggle", {
                            attrs: { text: "HPSF" },
                            model: {
                              value: _vm.configurations.hpsf,
                              callback: function($$v) {
                                _vm.$set(_vm.configurations, "hpsf", $$v)
                              },
                              expression: "configurations.hpsf"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-md-4" },
                        [
                          _c("Toggle", {
                            attrs: { text: "Labcorp" },
                            model: {
                              value: _vm.configurations.labCorp,
                              callback: function($$v) {
                                _vm.$set(_vm.configurations, "labCorp", $$v)
                              },
                              expression: "configurations.labCorp"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-md-4" },
                        [
                          _c("Toggle", {
                            attrs: { text: "Home Test Kit" },
                            model: {
                              value: _vm.configurations.htk,
                              callback: function($$v) {
                                _vm.$set(_vm.configurations, "htk", $$v)
                              },
                              expression: "configurations.htk"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row mt-3" }, [
                      _c("div", { staticClass: "col-md-4" }, [
                        _c("div", { staticClass: "text-entry-field-wrapper" }, [
                          _c(
                            "div",
                            {
                              staticClass: "text-entry-title display-flex-end",
                              class: { "opacity-06": !_vm.configurations.hpsf }
                            },
                            [
                              _c("span", [_vm._v("HPSF URL")]),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass: "display-space-between",
                                  class: { noDisplay: !_vm.configurations.hpsf }
                                },
                                [
                                  _vm.errors.has("hpsf")
                                    ? _c("span", {
                                        staticClass: "alert-icon-red-error"
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "error-text-color" },
                                    [_vm._v(_vm._s(_vm.errors.first("hpsf")))]
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.configurations.hpsfUrl,
                                expression: "configurations.hpsfUrl"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required|url:require_protocol",
                                expression: "'required|url:require_protocol'"
                              }
                            ],
                            staticClass: "text-input",
                            class: { "opacity-06": !_vm.configurations.hpsf },
                            attrs: {
                              disabled: !_vm.configurations.hpsf,
                              name: "hpsf",
                              placeholder: "Enter HPSF URL"
                            },
                            domProps: { value: _vm.configurations.hpsfUrl },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.configurations,
                                  "hpsfUrl",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-4" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-4" }, [
                        _c("div", { staticClass: "text-entry-field-wrapper" }, [
                          _c(
                            "div",
                            {
                              staticClass: "text-entry-title display-flex-end",
                              class: { "opacity-06": !_vm.configurations.htk }
                            },
                            [
                              _c("span", [_vm._v("Home Test Kit URL")]),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass: "display-space-between",
                                  class: { noDisplay: !_vm.configurations.htk }
                                },
                                [
                                  _vm.errors.has("htk")
                                    ? _c("span", {
                                        staticClass: "alert-icon-red-error"
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "error-text-color" },
                                    [_vm._v(_vm._s(_vm.errors.first("htk")))]
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.configurations.htkUrl,
                                expression: "configurations.htkUrl"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required|url:require_protocol",
                                expression: "'required|url:require_protocol'"
                              }
                            ],
                            staticClass: "text-input",
                            class: { "opacity-06": !_vm.configurations.htk },
                            attrs: {
                              disabled: !_vm.configurations.htk,
                              name: "htk",
                              placeholder: "Enter Home Test Kit URL"
                            },
                            domProps: { value: _vm.configurations.htkUrl },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.configurations,
                                  "htkUrl",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row mt-3" }, [
                      _c(
                        "div",
                        { staticClass: "col-md-4" },
                        [
                          _c("Toggle", {
                            attrs: { text: "SignUp Email" },
                            model: {
                              value: _vm.configurations.enableSignupEmail,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.configurations,
                                  "enableSignupEmail",
                                  $$v
                                )
                              },
                              expression: "configurations.enableSignupEmail"
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("hr", { staticClass: "mt-4 mb-4" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "participant-emails" }, [
                    _c("span", { staticClass: "title" }, [
                      _vm._v("Participant & Spouse Emails")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row mt-3" }, [
                      _c(
                        "div",
                        { staticClass: "col-md-8 text-entry-field-wrapper" },
                        [
                          _c("span", { staticClass: "text-entry-title" }, [
                            _vm._v("Participant Email Template")
                          ]),
                          _vm._v(" "),
                          _c("multiselect", {
                            staticClass: "multiple-select-work-group",
                            attrs: {
                              options: _vm.configurations.emailTemplateDtoList,
                              placeholder: "Choose Email Type",
                              label: "templateTypeName",
                              openDirection: "below",
                              "allow-empty": false,
                              "show-labels": false
                            },
                            on: { select: _vm.onSelectTemplate },
                            model: {
                              value: _vm.emailTemplate,
                              callback: function($$v) {
                                _vm.emailTemplate = $$v
                              },
                              expression: "emailTemplate"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row mt-3" }, [
                      _c(
                        "div",
                        { staticClass: "col-md-8 text-entry-field-wrapper" },
                        [
                          _c("span", { staticClass: "text-entry-title" }, [
                            _vm._v("Subject Line")
                          ]),
                          _vm._v(" "),
                          _c("vue-ckeditor", {
                            attrs: { config: _vm.configEmail },
                            on: { input: _vm.onChangeTemplate },
                            model: {
                              value: _vm.emailTemplate.emailSubject,
                              callback: function($$v) {
                                _vm.$set(_vm.emailTemplate, "emailSubject", $$v)
                              },
                              expression: "emailTemplate.emailSubject"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row mt-3" }, [
                      _c(
                        "div",
                        { staticClass: "col text-entry-field-wrapper" },
                        [
                          _c("span", { staticClass: "text-entry-title" }, [
                            _vm._v("Email body")
                          ]),
                          _vm._v(" "),
                          _c("vue-ckeditor", {
                            attrs: { config: _vm.configEmail },
                            on: { input: _vm.onChangeTemplate },
                            model: {
                              value: _vm.emailTemplate.body,
                              callback: function($$v) {
                                _vm.$set(_vm.emailTemplate, "body", $$v)
                              },
                              expression: "emailTemplate.body"
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "margin-top-44px group-btn" }, [
                    _c(
                      "button",
                      {
                        staticClass: "ap-btn primary ml-3",
                        class: { "opacity-04": _vm.isLoading },
                        attrs: {
                          id: "save-configure-scheduler",
                          disabled: _vm.isLoading
                        },
                        on: { click: _vm.onSave }
                      },
                      [_vm._v("Save")]
                    )
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("SchedulerPreview")
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "Popup",
        {
          attrs: {
            name: "saveConfigurationsModal",
            "cancel-text": "Cancel",
            "submit-text": "Save"
          },
          on: { onSubmit: _vm.saveConfigurations }
        },
        [
          _c("template", { slot: "header" }, [
            _vm._v("Are you sure to save these configurations?")
          ]),
          _vm._v(" "),
          _c("template", { slot: "body" }, [
            _vm._v(
              "Changing client level shiftboard teams assignment will overwrite all event level shiftboard teams assignments listed under this client."
            )
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1b4703dc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b4703dc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/ConfigureSchedulerModal.vue
// module id = 1656
// module chunks = 1